import React from "react"
import AttributionCookie from "src/utils/AttributionCookie"

const GclidCookie = () => <AttributionCookie name="gclid" />

export default GclidCookie
